import {useParams} from "react-router-dom";
import React from "react";
import "./styles/diary.css";
import Loader from "../common/PageLoader";
import { useDiarySectionPage } from "../../features/diarySection/model/useDiarySectionPage";
import DiarySectionContent from "../../features/diarySection/components/DiarySectionContent";

export default function DiarySectionPageComponent() {
    const { section } = useParams();
    const { user, isLoading } = useDiarySectionPage();

    if (isLoading || !user?.name) return <Loader/>;

    return <DiarySectionContent section={section} user={user} />;
}
